import PropTypes from 'prop-types';
import React from 'react';

import { Image } from '$partials/media/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleTimelineBlock = ({
    anchorNav,
    heroMedia,
    heading,
    body,
    image,
    index,
    items,
    isAccordionOrSection,
    isFirstInAccordion,
    isDetailPage,
    subheading
}) => {
    return (
        <section className='relative'>
            <div className='layout-container'>
                <div className='layout-grid-negative-gutter flex'>
                    <div className='md:w-1/12' />
                    <div className='w-12/12 md:w-11/12 layout-grid-col-padding'>
                        <div className={((isDetailPage || isAccordionOrSection) && !isFirstInAccordion && index === 0 && !anchorNav && !heroMedia) ? 'border-t border-t-charcoal' : ''} />
                    </div>
                </div>
            </div>

            <div className={`relative mt-40 mb-60${isAccordionOrSection ? ' md:mt-30 md:mb-20' : ' md:mt-60 md:mb-100'}`}>
                {!isAccordionOrSection && (
                    <div className='layout-container'>
                        <div className='layout-grid-negative-gutter md:flex md:pt-40'>
                            <div className='md:w-1/12' />

                            <div className='md:w-11/12'>
                                {heading && (
                                    <h2 className='pb-40 type-style-1 layout-grid-col-padding sm:w-8/12 sm:pt-30 sm:pr-40'>
                                        {heading}
                                    </h2>
                                )}

                                {body && (
                                    <p className='type-style-4 layout-grid-col-padding pb-40 sm:w-8/12'>{body}</p>
                                )}

                                {image && (
                                    <figure className='layout-grid-col-padding w-4/12 sm:w-2/12 md:w-1/11 pb-40 md:pb-60'>
                                        <Image
                                            {...image.image}
                                            alt={image?.image?.alt} />
                                    </figure>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                <div className='layout-container'>
                    <div className='layout-grid-negative-gutter flex'>
                        <div className='md:w-1/12' />

                        <div className='w-12/12 md:w-11/12 layout-grid-col-padding'>
                            <div className={`${!isAccordionOrSection ? 'hidden sm:block border-t sm:border-t-charcoal' : ''}`} />
                        </div>
                    </div>

                    <div className='layout-grid-negative-gutter sm:flex'>
                        <div className='md:w-1/12' />

                        {subheading && heading && (
                            <h3 className='type-style-3 pb-40 sm:pt-30 layout-grid-col-padding sm:w-4/12'>
                                {subheading}
                            </h3>
                        )}

                        {subheading && !heading && (
                            <h2 className='type-style-3 pb-40 sm:pt-30 layout-grid-col-padding sm:w-4/12'>
                                {subheading}
                            </h2>
                        )}

                        {!subheading && (
                            <div className='pb-40 sm:pt-30 layout-grid-col-padding sm:w-4/12' />
                        )}

                        <ul className='layout-grid-col-padding sm:w-8/12 md:w-7/12'>
                            {items?.map((item, idx) => {
                                return (
                                    <React.Fragment key={idx}>
                                        <li className={`${idx === 0 ? 'sm:border-t-0' : ''} border-t border-t-charcoal pt-30 pb-40 md:py-30 md:flex md:items-end md:gap-20`}>
                                            <p className='type-style-4 pb-15 md:pb-0'>{item.year}</p>
                                            <h3 className='type-style-3'>{item.description}</h3>
                                        </li>
                                    </React.Fragment>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    anchorNav: PropTypes.bool,
    heroMedia: PropTypes.bool,
    className: PropTypes.string,
    heading: PropTypes.string,
    body: PropTypes.string,
    image: PropTypes.object,
    index: PropTypes.number,
    items: PropTypes.array,
    isAccordionOrSection: PropTypes.bool,
    isFirstInAccordion: PropTypes.bool,
    isDetailPage: PropTypes.bool,
    subheading: PropTypes.string
};


ModuleTimelineBlock.propTypes = propTypes;

export default ModuleTimelineBlock;
